<template>
  <section class="is-medium">
    <div class="columns is-gapless is-centered">
        <div class="column hero is-fullheight">
          <div class="hero-body">
            <article class="card is-rounded">
              <form v-if="!has_user_record" novalidate @submit.prevent="submitForm">
                <div class="card-content">
                  <h1 class="title">
                    <img src="/static/img/HPB-logo-on-white.svg" alt="logo" width="500">
                  </h1>
                  <flash-message size="is-size-6"></flash-message>
                  <br/>
                  <div class="has-text-centered" v-if="!verified">
                    <p class="tag is-small is-warning is-loading"> <i
                            class="fa fa-spinner fa-spin"></i> &nbsp;Verifying Invite...</p>
                  </div>
                  <div v-if="!fetching_data">
                    <div class="columns is-mobile is-marginless">
                      <div class="column is-narrow is-marginless is-centered is-info">
                        <span class="icon is-size-4 is-white">
                          <i class="fas fa-info-circle"></i>
                        </span>
                      </div>
                      <div class="column is-marginless is-info-middle">
                        <p class="is-size-6" v-if="!invalid_invite">You've been invited to join Hellopeter. Please create an account to access the business portal.</p>
                      </div>
                    </div>
                    <br/>
                    <p class="control">
                      <input :disabled="sending" class="input" type="text" name="first_name" placeholder="First Name" v-model="form.first_name"/>
                    </p>
                    <p class="control">
                      <input :disabled="sending" class="input" type="text" name="last_name" placeholder="Last Name" v-model="form.last_name"/>
                    </p>
                    <p class="control">
                      <input :disabled="sending" class="input" type="password" name="password" placeholder="Password" v-model="form.password"/>
                    </p>
                    <p class="control">
                      <input :disabled="sending" class="input" type="password" name="confirm_password" placeholder="Confirm Password" v-model="confirm_password"/>
                    </p>
                    <p class="control">
                      <button id="submitButton" type="submit"
                              class="button is-fullwidth is-button-blue"
                              :class="[{'is-loading': sending}]">CREATE ACCOUNT</button>
                    </p>
                  </div>
                </div>
              </form>
              <form v-else novalidate @submit.prevent="joinBusiness">
                <h1 class="title">
                  <img src="/static/img/HPB-logo-on-white.svg" alt="logo" width="500">
                </h1>
                <flash-message size="is-size-6"></flash-message>
                <br/>
                <div class="has-text-centered" v-if="!verified">
                  <p class="tag is-small is-warning is-loading"> <i
                          class="fa fa-spinner fa-spin"></i> &nbsp;Verifying Invite...</p>
                </div>
                <div v-if="!fetching_data">
                  <div class="columns is-mobile is-marginless">
                    <div class="column is-narrow is-marginless is-centered is-info">
                      <span class="icon is-size-4 is-white">
                        <i class="fas fa-info-circle"></i>
                      </span>
                    </div>
                    <div class="column is-marginless is-info-middle">
                      <p class="is-size-6" v-if="!invalid_invite">You've been invited to join the {{ business_name }} account on Hellopeter.</p>
                    </div>
                  </div>

                  <p class="control biz-add-btn">
                    <button type="submit"
                            class="button is-fullwidth is-button-blue"
                            :class="[{'is-loading': sending}]">ADD THIS BUSINESS TO YOUR ACCOUNT</button>
                  </p>
                </div>
              </form>
            </article>
          </div>
        </div>
    </div>
  </section>
</template>
<script>
  /* eslint-disable indent,no-new,no-undef */
  import ApiResource from '../../api/ApiResource'
  import FlashMessage from '../../components/FlashMessageStrip'
  import misc from '../../mixins/misc.js'
  import axios from 'axios'

  export default {
    metaInfo: {
      title: 'Business Portal | Hellopeter - Accept Invite'
    },
    mounted () {
      this.$gtm.trackEvent({
        event: 'pageLoad',
        virtualPageUrl: this.$router.currentRoute.path,
        virtualPageTitle: 'Accept Invite'
      })
    },
    components: {
      FlashMessage
    },
    mixins: [misc],
    props: ['id'],
    created () {
      this.fetching_data = true
      this.verifyInvite()
    },
    data () {
      return {
        fetching_data: false,
        verified: false,
        sending: false,
        fetching: true,
        invalid_invite: false,
        confirm_password: '',
        has_errors: false,
        has_user_record: false,
        business_name: '',
        form: new ApiResource({
          first_name: '',
          last_name: '',
          password: ''
        })
      }
    },
    watch: {
      has_errors () {
        if (this.form.errors.any()) {
          flash(this.getErrorMessage(), 'is-danger')
        }
      },
      invalid_invite () {
        if (this.invalid_invite) {
          flash('This invite is no longer valid.', 'is-danger')
        }
      }
    },
    computed: {},
    methods: {
      getErrorMessage () {
        return this.form.errors.getDefaultErrorMessage()
      },
      /**
       * Makes an api call to get to verify an invite
       * @returns {void}
       */
      verifyInvite () {
        const invite = new ApiResource({})
        invite.send(`/auth/${this.id}/invite`, {}, 'get')
          .then((response) => {
            this.verified = true
            if (response.status === 'REVOKED' || response.status === 'ACCEPTED') {
              this.$router.push({path: '/login', query: {invite: response.status.toLowerCase().trim()}})
            } else {
              this.fetching_data = false
              this.has_user_record = response.existing_user
              this.business_name = response.business.name
            }
          })
          .catch(() => {
            this.fetching_data = false
            this.verified = false
            this.$router.push('/404')
          })
      },
      /**
       * Processes form submission
       * @returns {void}
       */
      submitForm () {
        this.form.errors.clear(null)
        if (this.passwordsMatch()) {
          this.sending = true
          this.has_errors = false

          this.form.send(`/auth/${this.id}/invite`)
            .then(() => {
              localStorage.clear()
              this.sending = false
              localStorage.setItem('auth_token', this.form.token)
              localStorage.setItem('first_name', this.form.first_name)
              localStorage.setItem('last_name', this.form.last_name)
              localStorage.setItem('roles', JSON.stringify(this.form.roles))
              localStorage.setItem('org_slug', this.form.org_slug)
              localStorage.setItem('is_hp_admin', JSON.parse(this.form.is_hp_admin))
              localStorage.setItem('can_add_more_users', JSON.parse(this.form.can_add_more_users))

              axios.get(`/${this.form.org_slug}/billing-details`)
                .then(({data}) => {
                  localStorage.setItem('billingDetails', JSON.stringify(data))
                  // push GTM event
                  this.$gtm.trackEvent({
                    event: 'conversionSuccess',
                    type: 'Login'
                  })
                  this.setDefaultBusiness(this.form.roles)
                  this.$router.push('/')
                })
              })
            .catch((msg) => {
              if (msg.error === 'This invite is no longer valid.') {
                this.invalid_invite = true
              }
              this.has_errors = true
              this.sending = false
            })
        } else {
          flash('The passwords do not match', 'is-danger')
        }
      },
      /**
       * Checks if passwords supplied matches
       * @returns {boolean}
       */
      passwordsMatch () {
        return this.form.password === this.confirm_password
      },
      /**
       * Joining a business - same as accept invite just that this is for a case when we don't need to accept user input fields for first
       * name and last name and password as we already have a user record in the database
       * @returns {void}
       */
      joinBusiness () {
        this.sending = true
        this.has_errors = false
        this.form = new ApiResource({})
        this.form.send(`/auth/${this.id}/join`)
          .then(() => {
            this.sending = false
            this.$router.push('/')
          })
          .catch((error) => {
            this.has_errors = true
            this.sending = false
            if (error.error === 'This invite is no longer valid.') {
              this.invalid_invite = true
            }
          })
      }
    }
  }
</script>
<style scoped>
  .control {
	  margin-bottom: 10px;
  }

  input{
    border-radius: 0 !important;
    border: 1px solid #dbdbdb !important;
    box-shadow: none !important;
  }

  article {
    max-width: 450px;
    margin-left: auto;
    margin-right: auto;
    box-shadow: none;
  }

  .is-success-middle {
    background-color: #b9efdd;
  }

  .is-info-middle {
    background-color: #C6E2EF;
  }

  .is-warning-middle {
    background-color: #faddc1;
  }

  .is-danger-middle {
    background-color: #fbcdc6;
  }

  .is-success {
    color:#fff;
    background-color: #16be85;
  }

  .is-warning{
    color:#fff;
    background-color: #fb922c;
  }

  .is-danger {
    color:#fff;
    background-color: #fb492c;
  }

  .is-info {
    color:#fff;
    background-color: #31AAE1;
  }

  a.icon {
    text-decoration: none;
    color: #58595b;
  }
  .biz-add-btn {
    margin-top: 17px !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/invites/Accept.vue